// src/components/layout/DashboardLayout.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useNotification } from '../../contexts/NotificationContext';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import AlertBanner from '../common/AlertBanner';

const DashboardLayout = ({ children }) => {
  const navigate = useNavigate();
  const { currentUser, vendorProfile } = useAuth();
  const { alert } = useNotification();
  
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  // Check if user is authenticated
  useEffect(() => {
    if (!currentUser) {
      navigate('/login');
    }
  }, [currentUser, navigate]);
  
  // Close mobile menu on route change
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [navigate]);
  
  if (!currentUser) {
    return null; // Don't render anything while checking auth
  }
  
  return (
    <div className="h-screen flex flex-col bg-gray-50">
      {/* Alerts */}
      {alert.show && (
        <AlertBanner
          message={alert.message}
          type={alert.type}
        />
      )}
      
      {/* Navbar */}
      <Navbar onMobileMenuToggle={() => setMobileMenuOpen(!mobileMenuOpen)} />
      
      {/* Main Content */}
      <div className="flex-grow flex overflow-hidden">
        {/* Sidebar - desktop */}
        <div className="hidden md:flex md:flex-shrink-0">
          <Sidebar />
        </div>
        
        {/* Sidebar - mobile */}
        {mobileMenuOpen && (
          <>
            {/* Backdrop */}
            <div 
              className="fixed inset-0 z-40 bg-gray-600 bg-opacity-75 md:hidden"
              onClick={() => setMobileMenuOpen(false)}
            />
            
            {/* Mobile menu */}
            <div className="md:hidden">
              <Sidebar
                isMobile
                onClose={() => setMobileMenuOpen(false)}
              />
            </div>
          </>
        )}
        
        {/* Main content area */}
        <main className="flex-1 relative z-0 overflow-y-auto focus:outline-none">
          <div className="py-6">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;